import React, {useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import {
  Modal,
} from 'react-bootstrap'
import { CountriesFilter } from "./countries-filter/CountriesFilter";
import { CountriesTable } from "./countries-table/CountriesTable";
import { CountriesGrouping } from "./countries-grouping/CountriesGrouping";
import { useCountriesUIContext } from "./CountriesUIContext";
import * as crud from "../../_redux/countries/countriesCrud";

export function CountriesCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }
 
  const navigate = useNavigate();
  const location = useLocation();
  
  let tab = "all";
  const pathParts = location.pathname.split("/");
  if (pathParts[2] === "approved" || pathParts[2] === "pending" || pathParts[2] === "rejected") {
    tab = pathParts[2];
  }

  const callFilterFunction = (val) => {
    if(val==="all")       { navigate(`/country/`); }
    if(val==="approved")  { navigate(`/country/approved`); }
    if(val==="pending")   { navigate(`/country/pending`); }
    if(val==="rejected")  { navigate(`/country/rejected`); }
  };

  const countriesUIContext = useCountriesUIContext();
  const [showcreatemodal, showCreateModal] = useState(false);
  const [name,setName] = useState('')
  const [isoCode, setIsoCode] = useState('')
  const [phonecode, setPhonecode] = useState('')
  const [currency, setCurrency] = useState('')
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [name_is_invalid,validateName] = useState('')
  const [processing,setProcessing] = useState(false)

  const sampleFunction = async (event,val) => {
    event.stopPropagation()
    showCreateModal(val)
  };
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const createCountry = async (event) => {
    let validations_ok = true
    validateName("")
    if(name===""){
      validations_ok = false
      validateName("is-invalid");
    }

    if(validations_ok){
      setProcessing(true)
      await crud.createCountry({
        name,
        isoCode,
        phonecode,
        currency,
        latitude,
        longitude
      });
      await delay(1000);
      showCreateModal(false)
      setProcessing(false)
      
      // Reset form
      setName('')
      setIsoCode('')
      setPhonecode('')
      setCurrency('')
      setLatitude('')
      setLongitude('')
    }


  }
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      queryParams: countriesUIContext.queryParams,
      setQueryParams: countriesUIContext.setQueryParams,
      newCountryButtonClick: countriesUIContext.newCountryButtonClick,
      openDeleteCountriesDialog: countriesUIContext.openDeleteCountriesDialog,
      openEditCountryPage: countriesUIContext.openEditCountryPage,
      openUpdateCountriesStatusDialog:
        countriesUIContext.openUpdateCountriesStatusDialog,
      openFetchCountriesDialog: countriesUIContext.openFetchCountriesDialog,
    };
  }, [countriesUIContext]);
  return (
    
    <Card>
      <Modal centered show={showcreatemodal} onHide={() => showCreateModal(false)}>
          <Modal.Header >
              <Modal.Title>New Country</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div className="row">
                  <div className="col-md-12 form-group mt-3">
                    <input onChange={event => setName(event.target.value)} value={name} className={`form-control ${name_is_invalid}`} type="text" placeholder="Country Name *" />
                    <div className="invalid-feedback">Name is invalid</div>
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setIsoCode(event.target.value)} value={isoCode} className="form-control" type="text" placeholder="ISO Code (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setPhonecode(event.target.value)} value={phonecode} className="form-control" type="text" placeholder="Phone Code (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setCurrency(event.target.value)} value={currency} className="form-control" type="text" placeholder="Currency (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3"></div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLatitude(event.target.value)} value={latitude} className="form-control" type="text" placeholder="Latitude (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLongitude(event.target.value)} value={longitude} className="form-control" type="text" placeholder="Longitude (Optional)" />
                  </div>
              </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={(event)=>sampleFunction(event,false)} >
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={()=>createCountry()} >
            { processing===true ? <i className="fas fa-circle-notch fa-spin"></i> : 'Save'}
            </button>
          </Modal.Footer>
      </Modal>
      <CardHeader title="Country List">
        <CardHeaderToolbar>
        {
         (superadmin)? <button  type="button" className="btn btn-primary" onClick={(event)=>sampleFunction(event,true)} > New Country </button>:<></>
        }
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <CountriesFilter />
        {countriesUIProps.ids.length > 0 && superadmin && (
          <>
            <CountriesGrouping />
          </>
        )}

        <CountriesTable />
      </CardBody>
    </Card>
  );
}
